import {motion} from 'framer-motion'
import {twJoin} from 'tailwind-merge'

import {RightAnimation} from '../../../../animations'

import type {PropsWithChildren} from 'react'

export const TocPanel = ({children}: PropsWithChildren) => (
  <motion.div
    className={twJoin(
      'fixed right-0 z-[70] h-dvh',
      'ml-spacing-48 max-w-[340px] md:ml-auto md:max-w-[440px]',
    )}
    transition={{bounce: 0, duration: 0.3, ease: 'easeOut'}}
    {...RightAnimation}
  >
    <div className={'flex h-dvh min-h-0 flex-col overflow-hidden bg-surface-primary'}>
      {children}
    </div>
  </motion.div>
)
